import React, { createContext, useContext, useState, useCallback } from 'react';
// import SpinnerLoader from '../components/Shared23/SpinnerLoader';

const LoaderContext = createContext({
  loading: false,
  showLoader: () => {},
  hideLoader: () => {}
});

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const showLoader = useCallback(() => setLoading(true), []);
  const hideLoader = useCallback(() => setLoading(false), []);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      {/* <SpinnerLoader visible={loading} /> */}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);

export default LoaderContext;
